import MainComparisonWrapper from './components/MainComparisonWrapper.svelte';
import { mount } from 'svelte';

const loadRecommendationsForComparisonTable = ({ target, variationId, eventMergeId }) => {
  const cinemaInjectionContainerWidth = target.offsetWidth;

  mount(MainComparisonWrapper, {
    target,
    props: {
      variationId,
      eventMergeId,
      cinemaInjectionContainerWidth,
      featureIndex: target.parentNode.dataset.featureOrder || '99',
      additionalTrackingLabels: JSON.parse(target.parentNode.dataset.featureTrackingLabels || null)
    }
  });
  return Promise.resolve();
};

window.o_reco = window.o_reco || {};
window.o_reco.api = window.o_reco.api || {};
window.o_reco.api.loadRecommendationsForComparisonTable = loadRecommendationsForComparisonTable;

window.o_global.eventQBus.emitModuleLoaded('ft6bcn.reco-comparison-frontend.assets');
